import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveTurnsAction, updateTurnsAction } from '../../../actions/turnsActions';
import { listJudgesAction } from '../../../actions/judgesActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
//Función principal
const TurnForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refJuez = useRef();
    //Datos iniciales
    const initialData = {
        juez: '',
        inicio: '',
        fin: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const turnsLoading = useSelector( state => state.turns.loadingSave );
    const errorSave = useSelector( state => state.turns.errorSave );
    const isEdit = useSelector( state => state.turns.isEdit );
    const turnSelected = useSelector( state => state.turns.turnSelected );
    const judges = useSelector( state => state.judges.judges );
    //Inicializo el state local
    const [ turn, setTurn ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && turnSelected){
            setTurn({
                ...turnSelected,
                juez: turnSelected.juez.id
            });
        }else{
            setTurn(initialData);
        }
    }, [isEdit, turnSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setTurn({
            ...turn,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            juez: {
                id: values.juez
            },
            inicio: values.inicio,
            fin: values.fin,
            activo: 1,
            asignadas: 0
        }
        //Verifico si es edición o alta
        if(turn.id){
            //Agrego el ID
            data = {
                id: turn.id,
                ...data
            }
            //Es edición
            dispatch( updateTurnsAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveTurnsAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si cargó los jueces
        if(!judges){
            const params = {
                search: 'activo:1',
                sort: 'apellido:asc,nombre:asc'
            }
            //Llamo al dispatch
            dispatch( listJudgesAction(params) );
        }
        //Pongo el foco en el primer campo
        refJuez.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setTurn(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        juez: yup.number().required(),
        inicio: yup.date().required(),
        fin: yup.date().required().min(yup.ref('inicio'))
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Turno&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...turn }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                            <Form.Group className="col-md-12">
                                    <label htmlFor="juez">Juez/Magistrado</label>
                                    <Form.Control
                                        as="select"
                                        id="juez"
                                        className="form-control"  
                                        name="juez" 
                                        autoFocus 
                                        value={ values.juez }
                                        onChange={handleChange}
                                        isInvalid={!!errors.juez}
                                        disabled={ turnsLoading }
                                        ref={refJuez}
                                    >
                                        <option value="">Seleccione un Juez/Magistrado</option>
                                        {
                                            judges ? (
                                                judges.map(judge => (
                                                    <option value={judge.id} key={`ij${judge.id}`}>
                                                        { `${judge.apellido}, ${judge.nombre}`  }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.juez }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="inicio">Fecha inicio</label>
                                    <Form.Control
                                        id="inicio"
                                        className="form-control" 
                                        name="inicio" 
                                        type="date" 
                                        value={ values.inicio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.inicio}
                                        disabled={ turnsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.inicio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="fin">Fecha fin</label>
                                    <Form.Control
                                        id="fin"
                                        className="form-control" 
                                        name="fin" 
                                        type="date" 
                                        value={ values.fin }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fin}
                                        disabled={ turnsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                turnsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ turnsLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ turnsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default TurnForm;